import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import * as moment from 'moment';

import { EditBatchLabelComponent } from "src/components/manage-label/bulk-batch-label/edit-batch-label/edit-batch-label.component";
import { SetProductionQtyComponent } from "../set-production-qty/set-production-qty.component";
import { BatchService } from "src/services/batch.services";
import { GlobalCfgService } from "src/services/globalcfg.service";
import { MedicineService } from "src/services/medicine.services";
import { MessageService } from "src/services/message.service";
import { SubscriptionService } from "src/services/subscription.service";
import { Utils } from 'src/services/utils';

@Component({
    selector: 'rm-view-bulk-batch-dialog',
    templateUrl: './view-bulk-batch-dialog.component.html',
    styleUrls: ['./view-bulk-batch-dialog.component.css']
})

export class ViewBulkBatchComponet implements OnInit {
    form: FormGroup;
    gcp: string;
    medicines: any[];
    mfgDate: any;
    expiryDate: string;
    disableSelectedBatch: boolean = true;
    updateAction: boolean;
    //labels grid initial data variables...
    batchData: any[] = [];
    columns: any[];
    grossValue: number = null;
    tareValue: number = null;
    netValue: number = null;
    isLabelAlsoInner: boolean = false;
    containerValue: number = null;
    totalContainers: number;
    totalNetWeight: number = 0;
    currentOrgObj: any;
    showOrigin: boolean = false;
    batchDetails: any;

    constructor(private dialogRef: MatDialogRef<ViewBulkBatchComponet>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private _formBuilder: FormBuilder,
        private dialog: MatDialog,
        private globalCfgService: GlobalCfgService,
        private medicineService: MedicineService,
        private subscriptionService: SubscriptionService,
        private batchService: BatchService,
        private msgService: MessageService,
        private utils: Utils,
    ) {}

    ngOnInit(): void {
        this.form = this._formBuilder.group({
            isNeutralLabel: false,
            showOrigin: false,
            gtin: new FormControl,
            toPrintCustomProductName: false,
            toPrintProductName: new FormControl(),
            updateExistingBatch: false,
            batchNo: new FormControl(),
            aRNo: '',
            mfgDate: new FormControl({ disabled: true, value: '' }, [Validators.required]),
            expiryDate: new FormControl({ disabled: true, value: '' }, [Validators.required]),
            storageCondition: ''
        })

        //Grid columuns data  
        this.columns = [
            { name: 'grossweight', displayName: "Gross Weight", actionable: true, },
            { name: 'tareweight', displayName: "Tare Weight", actionable: true, },
            { name: 'netweight', displayName: "Net Weight", actionable: true, },
            { name: 'container', displayName: "Container", actionable: true, },
            { name: "actions", type: "actions", displayName: "" },
        ];

        if (!this.gcp) {
            this.gcp = this.globalCfgService.getGcp();

            // get current org data to check if isAlsoInner option is to be displayed
            const filter = { "where": { "gcp": this.globalCfgService.getGcp() } };
            this.subscriptionService.getCurrentOrgData(filter).subscribe(
                (response: any) => {
                    if (response.count === 1) {
                        this.currentOrgObj = response.data[0];
                    }
                }
            );
        }


        this.updateAction = this.data.toogleActionBtns;
        this.bulkBatchData();
        this.loadMedicines();
        this.loadBatchDetails();
        if (this.updateAction) {
            this.prefillFromExistingLabels();
        } else {
            this.getBatchLabels();
        }
    }

    //batch reconciliation figures come from the server, not a client re-sum
    loadBatchDetails() {
        this.batchService.getBatchDetails(this.data.rec.batchNo).subscribe((res: any) => {
            this.batchDetails = res;
        });
    }

    loadMedicines() {

        var gcp = this.globalCfgService.getGcp();

        this.medicineService.getList(gcp).subscribe(
            (response: any) => {
                this.medicines = response;
            }
        );
    }

    bulkBatchData() {
        this.form.patchValue({
            'gtin': this.data['rec'].gtin,
            'batchNo': this.data['rec'].batchNo,
            'expiryDate': this.data['rec'].expiryDt,
            'mfgDate': this.data['rec'].batchDt
        });
        this.mfgDate = this.data['rec'].batchDt;
        this.expiryDate = this.data['rec'].expiryDt;
        this.form.get('batchNo').disable();
        this.form.get('gtin').disable();
        if (!this.updateAction) {
            this.form.get('toPrintCustomProductName').disable();
            this.form.get('isNeutralLabel').disable();
        }
        // this.form.get('isNeutralLabel').enable();
    }



    cancel() {
        this.dialogRef.close();
    }

    onSubmit() { }


    /**
     * Some orgs work from the tare of the empty container and the net quantity
     * filled into it, so they enter those two and gross is the computed sum.
     * Reads data.currentOrgObj, which arrives synchronously with the dialog -
     * this.currentOrgObj is only fetched later, and the template would flip mode
     * under the operator once it landed.
     */
    get isNetWeightEntry(): boolean {
        return !!(this.data.currentOrgObj && this.data.currentOrgObj.isNetWeightEntered);
    }

    /** live gross for the read only box; null until both operands are filled */
    get computedGrossValue(): number {
        return this.utils.grossFromTareAndNet(this.tareValue, this.netValue);
    }

    addBulkLabel() {
        const gross = this.isNetWeightEntry ? this.computedGrossValue : this.grossValue;

        if (gross && this.tareValue && this.containerValue) {
            let newLbelObj: any = {
                grossweight: gross,
                tareweight: this.tareValue,
                netweight: (gross - this.tareValue).toFixed(this.currentOrgObj.labelWeightDecimals ? this.currentOrgObj.labelWeightDecimals : 3),
                isAlsoInner: false,
                container: this.containerValue,
                actions: [{ name: 'close', tip: 'delete' }]
            };
            if (this.currentOrgObj.isInnerUsed) {
                newLbelObj.isAlsoInner = this.isLabelAlsoInner;
            }
            this.batchData.push(newLbelObj);
            this.grossValue = null;
            this.tareValue = null;
            this.netValue = null;
            this.containerValue = null;
            if (this.currentOrgObj.isInnerUsed) {
                this.isLabelAlsoInner = false;
            }
            this.totalNetWeightValue();
        }
    }

    removeBulkLabel(index) {
        if (index > -1) {
            this.batchData.splice(index, 1);
        }
        this.totalNetWeightValue();
    }

    /**
     * View mode only. An issued label cannot be edited in place - the ledger
     * entry is immutable - so "editing" one voids it and issues a replacement.
     */
    updateBulkLabel(index) {
        const label = this.batchData[index];

        if (!label || label.cancelled) {
            return;
        }

        const dialogRef = this.dialog.open(EditBatchLabelComponent, {
            disableClose: true,
            width: "500px",
            data: {
                title: 'Void & Reissue Label',
                batchLabel: { ...label },
                currentOrgObj: this.currentOrgObj,
                isReplace: true
            }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (!result) {
                return;
            }
            this.updateBulkBatchAPILabel(label, result.data, result.reason);
        })
    }

    totalNetWeightValue() {
        this.totalContainers = this.batchData.length;
        // Number() is required - netweight is a toFixed string and would concatenate
        this.totalNetWeight = this.batchData.reduce(
            (accumulator, currentValue) => accumulator + Number(currentValue.netweight), 0);
    }

    // ------------------------------------------------------------------
    // Batch quantity reconciliation (display + client side guard only - the
    // network API and the chaincode remain authoritative)
    // ------------------------------------------------------------------

    get uomLabel(): string {
        return this.batchDetails && this.batchDetails.uom
            ? this.batchDetails.uom
            : (this.currentOrgObj && this.currentOrgObj.uom ? this.currentOrgObj.uom : '');
    }

    get isProductionQtyTracked(): boolean {
        return !!this.batchDetails && this.batchDetails.totalProductionQty !== undefined;
    }

    get totalProductionQty(): number {
        return this.isProductionQtyTracked ? Number(this.batchDetails.totalProductionQty) : null;
    }

    /** quantity already issued against the batch, per the server */
    get issuedQty(): number {
        return this.batchDetails && this.batchDetails.utilisedQty !== undefined
            ? Number(this.batchDetails.utilisedQty) : 0;
    }

    /**
     * Net weight of the rows pending in this dialog. Only meaningful in edit
     * mode - in view mode batchData holds the labels already issued, which the
     * server has already counted in issuedQty.
     */
    get pendingQty(): number {
        if (!this.updateAction) {
            return 0;
        }
        return this.batchData.reduce(
            (total, label) => total + (Number(label.grossweight) - Number(label.tareweight)), 0);
    }

    /**
     * A pre-inner label is nested inside an outer container and its mass is
     * already inside that container's net weight, so it contributes nothing to
     * batch utilisation. Mirrors weight.isTopLevelContainer on the server.
     */
    isTopLevelContainer(label): boolean {
        return label.parentContainer === undefined
            || label.parentContainer === null
            || String(label.parentContainer).length === 0;
    }

    get remainingQty(): number {
        return this.isProductionQtyTracked
            ? this.totalProductionQty - this.issuedQty - this.pendingQty
            : null;
    }

    get isOverProduction(): boolean {
        return this.isProductionQtyTracked && this.remainingQty < 0;
    }

    /**
     * One time backfill for batches created before reconciliation existed.
     * Only offered while the batch has no production quantity - once set it is
     * immutable, so the button disappears for good.
     */
    openSetProductionQty() {
        const dialogRef = this.dialog.open(SetProductionQtyComponent, {
            disableClose: true,
            width: "420px",
            data: {
                batchNo: this.data.rec.batchNo,
                uom: this.uomLabel,
                utilisedQty: this.issuedQty
            }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (!result) {
                return;
            }
            this.batchService.setProductionQty({
                batchNo: this.data.rec.batchNo,
                totalProductionQty: result.totalProductionQty
            }).subscribe((res: any) => {
                this.msgService.showSuccess(this.msgService.productionQtySet);
                this.batchDetails = { ...this.batchDetails, ...res };
            });
        });
    }

    //update the bulk batch details.....
    updateBulkBatchDetails() {

        if (this.isOverProduction) {
            this.msgService.showError(this.msgService.productionQtyExceeded);
            return;
        }

        let timeZone = this.utils.getTimeZoneFromDateString(moment(this.mfgDate).format());

        let rec: any = {
            batchNo: this.data.rec.batchNo,
            gtin: this.data.rec.gtin,
            toPrintCustomProductName: this.form.value.toPrintCustomProductName,
            toPrintProductName: this.form.value.toPrintCustomProductName ? this.form.value.toPrintProductName : '',
            mfgDate: this.mfgDate,
            expiryDate: this.expiryDate,
            eventTimeZoneOffset: timeZone,
            isNeutralLabel: this.form.value.isNeutralLabel,
            storageCondition: this.form.value.storageCondition,
            children: this.batchData
        }

        if (this.data.currentOrgObj.isInnerUsed) {
            rec.aRNo = this.form.value.aRNo;
            rec.showOrigin = this.form.value.showOrigin;
        }

        let refRec = this.mapBatchDetailsToLabels(rec, timeZone);

        this.updateBulkBatchLables(refRec);
    }


    //to update bulk batch api integration....
    updateBulkBatchLables(rec) {
        let refObj = {
            batchNo: rec['batchNo'],
            toPrintCustomProductName: rec.toPrintCustomProductName,
            toPrintProductName: rec.toPrintCustomProductName ? rec.toPrintProductName : '',
            children: rec.children,
        }

        this.batchService.addLabelToExisitngBulk(refObj).subscribe((res: any) => {
            this.msgService.showSuccess(this.msgService.bulkBatchCreate);
            res.labelFiles.forEach(labelFile => {
                window.open(labelFile, '_blank');
            });
            this.dialogRef.close(res);
        })
    }


    // to check if toPrintProductName is empty and then 
    // set it default name of product selected when checkbox is enabled
    checkAndSetToPrintProductName(toPrintCustomProductNameUpdatedVal: boolean) {
        console.log('srikanth hello world', this.data);
        if (toPrintCustomProductNameUpdatedVal && (this.form.value.toPrintProductName === null || this.form.value.toPrintProductName === '')) {
            if (this.form.value.gtin !== null) {
                let selectedProductIdx = this.medicines.findIndex(med => med.gtin === this.data.rec.gtin);
                this.form.patchValue({ 'toPrintProductName': this.medicines[selectedProductIdx].name });
            }
        }
    }

    //map batchdetails into children except batchNo
    mapBatchDetailsToLabels(rec, timeZone) {
        if (rec.children.length > 0) {
            let refObj = {
                toPrintCustomProductName: rec.toPrintCustomProductName,
                toPrintProductName: rec.toPrintProductName,
                mfgDate: this.mfgDate,
                expiryDate: this.expiryDate,
                eventTimeZoneOffset: timeZone,
                isNeutralLabel: rec.isNeutralLabel
            }
            if (rec.aRNo) {
                refObj['aRNo'] = rec.aRNo;
            }
            if (rec.storageCondition) {
                refObj['storageCondition'] = rec.storageCondition;
            }
            if (rec.showOrigin) {
                refObj['showOrigin'] = rec.showOrigin;
            }
            const labelChildren = rec.children.map((it) => { return { ...it, ...refObj } })

            rec.children = labelChildren;
        }
        return rec;
    }

    /**
     * Edit mode only. A.R. No and storage condition are the same for every label
     * of a batch but live on the label metadata, not on the batch, so read them
     * back off the labels already issued rather than making the operator
     * remember and retype them. They stay editable - a new consignment may
     * legitimately carry a different A.R. No.
     *
     * Deliberately does not touch batchData: in edit mode that is the list of
     * containers pending addition, and the labels already issued must not be
     * resubmitted.
     */
    prefillFromExistingLabels() {
        if (!this.data.currentOrgObj || !this.data.currentOrgObj.isInnerUsed) {
            return;
        }
        this.batchService.getBulkApiBatchLabel(this.data.rec.batchNo).subscribe((res: any) => {
            this.form.patchValue(this.utils.getBulkLabelDefaults(res, ['aRNo', 'storageCondition']));
        });
    }

    //get the batch all lables
    getBatchLabels() {
        this.batchService.getBulkApiBatchLabel(this.data.rec.batchNo).subscribe((res: any) => {
            if (res) {
                this.batchData = res.map((it) => {
                    let newObj: any = {};
                    newObj = { ...it.metadata };
                    newObj.id = it.id;
                    // void state, so the grid can mark a replaced label instead
                    // of silently dropping it
                    newObj.cancelled = it.cancelled;
                    newObj.voidReason = it.voidReason;
                    newObj.replacedBy = it.replacedBy;
                    newObj.replaces = it.replaces;
                    newObj.netweight = (newObj.grossweight - newObj.tareweight).toFixed(this.currentOrgObj.labelWeightDecimals ? this.currentOrgObj.labelWeightDecimals : 3);
                    return newObj;
                })
            }
        })
    }

    /**
     * Void the issued label and reissue it with the edited values. Sends the
     * whole of the original metadata with only the edited fields overridden, so
     * the reprint is identical to the original except for the correction.
     */
    updateBulkBatchAPILabel(original, edited, reason) {

        const child = { ...original, ...edited };

        // grid/void bookkeeping - none of it belongs in the label metadata
        delete child.id;
        delete child.netweight;
        delete child.actions;
        delete child.cancelled;
        delete child.voidReason;
        delete child.voidedAt;
        delete child.replacedBy;
        delete child.replaces;

        // Client side guard only - the network API and the chaincode remain
        // authoritative. A replacement costs the batch only the weight delta, and
        // a pre-inner label costs nothing at all: its mass is already counted
        // inside its parent container.
        const netOf = (label) => this.isTopLevelContainer(label)
            ? Number(label.grossweight) - Number(label.tareweight)
            : 0;

        const deltaQty = netOf(child) - netOf(original);

        if (this.isProductionQtyTracked && this.remainingQty - deltaQty < 0) {
            this.msgService.showError(this.msgService.productionQtyExceeded);
            return;
        }

        this.batchService.replaceBulkLabel({
            batchNo: this.data.rec.batchNo,
            instanceId: original.id,
            reason: reason,
            child: child
        }).subscribe((res: any) => {
            this.msgService.showSuccess(this.msgService.bulkLabelReplaced);

            if (res.labelFiles) {
                res.labelFiles.forEach(labelFile => {
                    window.open(labelFile, '_blank');
                });
            }

            // pick up the voided row, the new row and the moved reconciliation
            // figures without making the user reopen the dialog
            this.getBatchLabels();
            this.loadBatchDetails();
        })
    }
}